import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NiceSelectModule } from "ng-nice-select";
import { FilePondModule, registerPlugin } from 'ngx-filepond';

import { SharedModule } from '@teem/shared/shared.module';
import { CoreModule } from '@teem/core/core.module';

import { AddClientModalComponent } from '@teem/clients-module/modals/add-client-modal/add-client-modal.component';
import { ImportClientModalComponent } from '@teem/clients-module/modals/import-client-modal/import-client-modal.component';
import { EditClientComponent } from '@teem/clients-module/forms/edit-client/edit-client.component';
import { HeaderComponent } from '@teem/clients-module/components/header/header.component';
import { ClientsRoutingModule } from '@teem/clients-module/clients-routing.module';
import { ClientsComponent } from '@teem/clients-module/clients.component';

// Import filepond plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation/dist/filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop/dist/filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize/dist/filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform/dist/filepond-plugin-image-transform';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit';
import { NgxPaginationModule } from 'ngx-pagination';

registerPlugin( 
  FilePondPluginFileValidateType,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginImageEdit
);

@NgModule({
  declarations: [
    ClientsComponent,
    HeaderComponent,
    AddClientModalComponent,
    ImportClientModalComponent,
    EditClientComponent,
  ],
  entryComponents: [
    AddClientModalComponent,
    ImportClientModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ClientsRoutingModule,
    NiceSelectModule,
    SharedModule,
    CoreModule,
    FilePondModule,
    NgxPaginationModule
  ]
})
export class ClientsModule { }